export class DropdownConfigModel {
  private bindlabel: string;
  private bindvalue: string;
  private lazyload = true;
  private searchable = true;
  private clearable = true;
  private localsearch = true;
  private disabled = false;
  private placeholder = 'Select';
  private selectall = false;
  private multiselect = false;
  private addtag = true;
  private itemsimplearray = true;
  private pushonaddtag = true;
  private loading = false;
  public searchtext: string;
  private maxTagLength: number;
  // private showNoData: boolean;
  private noDataFoundMessage: boolean;

  constructor(
    placeholder?: string,
    multiselect?: boolean,
    selectall?: boolean,
    bindlabel?: string,
    bindvalue?: string,
    addtag?: boolean,
    lazyload?: boolean,
    searchable?: boolean,
    clearable?: boolean,
    localsearch?: boolean,
    disabled?: boolean,
    searchtext?: string,
    itemsimplearray?: boolean,
    pushonaddtag?: boolean,
    maxTagLength?: number,
    // showNoData?: boolean,
    noDataFoundMessage?: boolean,
  ) {
    if (lazyload !== undefined) {
      this.lazyload = lazyload;
    }
    if (searchable !== undefined) {
      this.searchable = searchable;
    }
    if (clearable !== undefined) {
      this.clearable = clearable;
    }
    if (bindlabel !== undefined) {
      this.bindlabel = bindlabel;
    }
    if (bindvalue !== undefined) {
      this.bindvalue = bindvalue;
    }
    if (localsearch !== undefined) {
      this.localsearch = localsearch;
    }
    if (disabled !== undefined) {
      this.disabled = disabled;
    }
    if (searchtext !== undefined) {
      this.searchtext = searchtext;
    }
    if (placeholder !== undefined) {
      this.placeholder = placeholder;
    }
    if (selectall !== undefined) {
      this.selectall = selectall;
    }
    if (multiselect !== undefined) {
      this.multiselect = multiselect;
    }
    if (addtag !== undefined) {
      this.addtag = addtag;
    }
    if (itemsimplearray !== undefined) {
      this.itemsimplearray = itemsimplearray;
    }
    if (pushonaddtag !== undefined) {
      this.pushonaddtag = pushonaddtag;
    }
    if (maxTagLength !== undefined) {
      this.maxTagLength = maxTagLength;
    }
  }

  getPlaceholder(): string {
    return this.placeholder;
  }

  getMultiSelect(): boolean {
    return this.multiselect;
  }

  setMultiSelect(multiselect: boolean): void {
    this.multiselect = multiselect;
  }

  getItemSimpleArray(): any {
    return this.itemsimplearray;
  }

  setItemSimpleArray(itemsimplearray: boolean): void {
    this.itemsimplearray = itemsimplearray;
  }

  getIsClearable(): boolean {
    return this.clearable;
  }

  getSearchText(): string {
    return this.searchtext;
  }

  getAddTag(): boolean {
    return this.addtag;
  }

  getPushOnAddTag(): boolean {
    return this.pushonaddtag;
  }

  getIsSearchable(): boolean {
    return this.searchable;
  }

  getSelectAll(): boolean {
    return this.selectall;
  }

  setSelectAll(selectall: boolean): void {
    this.selectall = selectall;
  }

  getBindLabel(): string {
    return this.bindlabel;
  }

  setBindLabel(bindlabel: string): void {
    this.bindlabel = bindlabel;
  }

  getBindValue(): string {
    return this.bindvalue;
  }

  setBindValue(bindvalue: string): void {
    this.bindvalue = bindvalue;
  }

  getLoading(): boolean {
    return this.loading;

  }

  setLoading(loading: boolean): void {
    this.loading = loading;
  }

  setShowNoData(show: boolean): void {
    this.noDataFoundMessage = show;
  }

  getShowNoData(): any {
    return this.noDataFoundMessage;
  }

  getLazyLoad(): boolean {
    return this.lazyload;
  }

  setLazyLoad(lazyload: boolean): void {
    this.lazyload = lazyload;
  }

  getMaxTagLength(): number {
    return this.maxTagLength;
  }

  setDisableValue(value: boolean): void {
    this.disabled = value;
  }

  getDisabledValue(): boolean {
    return this.disabled;
  }

}
